export enum SimCardSecurityEnum {
    PIN = 'pin',
    PUK = 'puk',
}